module.exports = __webpack_public_path__ + "img/epr-article-top-img_medium@2x.2ba03d8e.jpg";